import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import gql from "graphql-tag";
import { useQuery, useMutation } from "react-apollo";

const QUERY = gql`
  query {
    getCurrentActiveCases(
      entity_type: ""
      status_code: ""
      client_name: ""
      client_code: ""
      contract_number: ""
      contract_name: ""
      contract_id: ""
      start_date: ""
      end_date: ""
      sort: "contract_id"
      order: "DESC"
      page: 1
      finished: 0
      limit: 50
    ) {
      count
      countProspect
      countOpen
      countApprove
      countClose
    }
  }
`;

const ChartCaseOverview = (props) => {
  const { loading, error, data, refetch } = useQuery(QUERY);
  let open = data ? data.getCurrentActiveCases.countOpen : 0;
  let approve = data ? data.getCurrentActiveCases.countApprove : 0;
  let prospect = data ? data.getCurrentActiveCases.countProspect : 0;
  let canceled = data ? data.getCurrentActiveCases.countClose : 0;

  useEffect(() => {
    let timeout = setTimeout(function () {
      props.handleCStatus({
        open: open,
        approve: approve,
        prospect: prospect,
        canceled: canceled,
      });
    }, 10);
    return () => {
      clearTimeout(timeout);
    };
  }, data);

  let dataChart = [
    {
      name: "Open",
      y: open,
      drilldown: "Open",
    },
    {
      name: "Approve",
      y: approve,
      drilldown: "Approve",
    },
    {
      name: "on Prospect",
      y: prospect,
      drilldown: "on Prospect",
    },
    {
      name: "Canceled",
      y: canceled,
      drilldown: "Canceled",
    },
  ];

  const chart = {
    chart: {
      type: "column",
      width: 900,
    },
    title: {
      text: ``,
    },
    subtitle: {
      text: "",
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size:13px">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>',
    },

    series: [
      {
        name: "Cases",
        colorByPoint: true,
        data: dataChart,
      },
    ],
    drilldown: {
      series: [
        {
          name: "Open",
          id: "Open",
          data: [
            ["v65.0", 0.1],
            ["v64.0", 1.3],
            ["v63.0", 53.02],
            ["v62.0", 1.4],
            ["v61.0", 0.88],
            ["v60.0", 0.56],
            ["v59.0", 0.45],
            ["v58.0", 0.49],
            ["v57.0", 0.32],
            ["v56.0", 0.29],
            ["v55.0", 0.79],
            ["v54.0", 0.18],
            ["v51.0", 0.13],
            ["v49.0", 2.16],
            ["v48.0", 0.13],
            ["v47.0", 0.11],
            ["v43.0", 0.17],
            ["v29.0", 0.26],
          ],
        },
        {
          name: "Closed",
          id: "Closed",
          data: [
            ["v58.0", 1.02],
            ["v57.0", 7.36],
            ["v56.0", 0.35],
            ["v55.0", 0.11],
            ["v54.0", 0.1],
            ["v52.0", 0.95],
            ["v51.0", 0.15],
            ["v50.0", 0.1],
            ["v48.0", 0.31],
            ["v47.0", 0.12],
          ],
        },
        {
          name: "Offering",
          id: "Offering",
          data: [
            ["v11.0", 6.2],
            ["v10.0", 0.29],
            ["v9.0", 0.27],
            ["v8.0", 0.47],
          ],
        },
        {
          name: "on Prospect",
          id: "on Prospect",
          data: [
            ["v11.0", 3.39],
            ["v10.1", 0.96],
            ["v10.0", 0.36],
            ["v9.1", 0.54],
            ["v9.0", 0.13],
            ["v5.1", 0.2],
          ],
        },
        {
          name: "Canceled",
          id: "Canceled",
          data: [
            ["v16", 2.6],
            ["v15", 0.92],
            ["v14", 0.4],
            ["v13", 0.1],
          ],
        },
        {
          name: "Opera",
          id: "Opera",
          data: [
            ["v50.0", 0.96],
            ["v49.0", 0.82],
            ["v12.1", 0.14],
          ],
        },
      ],
    },
  };

  return (
    <div className="w-100">
      <HighchartsReact
        highcharts={Highcharts}
        options={chart}
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default ChartCaseOverview;
